<template>
  <div id="map" class="map" />
</template>
<script>
import { get } from 'vuex-pathify';
import { debounce } from 'lodash';

import { default as Map } from '../plugins/new_map';
import { GeoJSON } from 'ol/format';

import crs from '@/mixins/map/crs';
import view from '@/mixins/map/view';
import basemap from '@/mixins/map/basemap';

export default {
  name: 'DataInputMapview',
  mixins: [crs, view, basemap],
  props: {
    value: {
      type: Object,
      // Geojson point like:
      // { type: 'Point', coordinates: [x, y], crs: { type: 'name', properties: { name: 'EPSG:3857' } } }
    },
    height: {
      type: [Number, String],
      default: '30vh',
    },
    width: {
      type: [Number, String],
      default: '100%',
    },
  },
  computed: {
    initialMapView: get('admin/settingsValues@initial_map_view'),
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
  },
  methods: {
    initMap() {
      const { zoom, map_center } = { ...this.initialMapView, ...this.computedValue };
      const olGeometry = new GeoJSON().readGeometry(map_center, {
        // dataProjection: this.$_config.defaultEpsg,
        featureProjection: this.$_config.defaultEpsg,
      });
      const mapCenterCoordsInDefaultEpsg = olGeometry.getCoordinates();
      this.map = new Map({
        keyboardEventTarget: document,
        layers: [this.getBasicBasemapLayer()],
        target: 'map',
        view: this.prepareView({ center: mapCenterCoordsInDefaultEpsg, zoom }),
      });
      this.map.on('moveend', e => {
        this.setView(e.map);
      });
    },
    setView(map) {
      const zoom = map.getView().getZoom();
      const center = map.getView().getCenter();
      this.computedValue = {
        map_center: {
          type: 'Point',
          coordinates: center,
          crs: {
            type: 'name',
            properties: { name: this.$_config.defaultEpsg },
          },
        },
        zoom,
      };
    },
    beforeDestroy() {
      this.map.setTarget(null);
      this.map = null;
    },
  },
  mounted() {
    this.setView = debounce(this.setView, 500);
    this.initMap();
    this.$once('hook:beforeDestroy', this.beforeDestroy);
  },
};
</script>

<style lang="scss" scoped>
.map {
  width: v-bind(width);
  height: v-bind(height);
  @include border(all, 1px, #898989);
  border-radius: 5px;
}
::v-deep .ol-viewport {
  border-radius: inherit;
}
</style>
